export const OPEN_WEB_PAGE = 'OPEN_WEB_PAGE'
export const READ_TABLE = 'READ_TABLE'
export const FRAME = 'FRAME'
export const POPUP = 'POPUP'
export const SHOW = 'SHOW'
export const SNAP = 'SNAP'
export const DOM = 'DOM'
export const SCROLL = 'SCROLL'
export const BACK = 'BACK'
export const WEB_SCRAPPER = 'WEB_SCRAPPER'
